/**
 * Generated runtime TestId mirror for frontend/src/components/sources/SourcesCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SourcesCardTestIds = {
  bulkReleaseCancel: "bulk-release-cancel",
  bulkReleaseConfirm: "bulk-release-confirm",
  bulkReleaseDialog: "bulk-release-dialog",
  detachSourceCancel: "detach-source-cancel",
  detachSourceConfirm: "detach-source-confirm",
  detachSourceDialog: "detach-source-dialog",
  sectionSources: "section-sources",
  sourcesEmpty: "sources-empty",
  sourcesError: "sources-error",
  sourcesLoading: "sources-loading",
  sourcesRetry: "sources-retry",
  sourceExternalId: (source_id: string) => `source-external-id-${source_id}`,
  sourceExternalIdPrefix: () => "source-external-id-" as TestIdPrefix,
  sourceRow: (source_id: string) => `source-row-${source_id}`,
  sourceRowPrefix: () => "source-row-" as TestIdPrefix,
  sourceRowDetach: (source_id: string) => `source-row-detach-${source_id}`,
  sourceRowDetachPrefix: () => "source-row-detach-" as TestIdPrefix,
  sourceRowMenu: (source_id: string) => `source-row-menu-${source_id}`,
  sourceRowMenuPrefix: () => "source-row-menu-" as TestIdPrefix,
  sourceRowReleaseAll: (source_id: string) => `source-row-release-all-${source_id}`,
  sourceRowReleaseAllPrefix: () => "source-row-release-all-" as TestIdPrefix,
  sourceTargetSystem: (source_id: string) => `source-target-system-${source_id}`,
  sourceTargetSystemPrefix: () => "source-target-system-" as TestIdPrefix
} as const;
